module.exports = __webpack_public_path__ + "static/media/05.247921f6.svg";